import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, theme } from 'antd';
import App from './App';

const rootElement = document.getElementById('root');
const app = (
    <React.StrictMode>
        <ConfigProvider
            theme={{
                algorithm: theme.darkAlgorithm,
                token: {
                    colorPrimary: '#6366f1',
                    colorBgBase: '#0a0a0f',
                    colorBgContainer: '#1a1a24',
                    colorBgElevated: '#1a1a24',
                    colorBorder: 'rgba(255,255,255,0.08)',
                    colorText: '#ffffff',
                    colorTextSecondary: '#a1a1aa',
                    borderRadius: 8,
                    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', 'PingFang SC', sans-serif",
                },
            }}
        >
            <App />
        </ConfigProvider>
    </React.StrictMode>
);

// react-snap 预渲染的静态内容供爬虫读取，用户访问时正常渲染
ReactDOM.createRoot(rootElement).render(app);
